<div class="step-1" *ngIf="step == 'step-1'">
  <div class="text-center mb-5">
    <h3>
      {{ "CRYPTO.SELECT_YOUR_CRYPTO_CURRENCY_DEPOSIT_METHOD" | translate }}
    </h3>
  </div>
  
  <!-- Amount Input Section -->
  <div class="amount-input d-flex justify-content-center align-items-center flex-wrap crypto-selection-container">
    <div
    *ngFor="let crypto of cryptoCurrencies;"
      class="{{ crypto.network }} crypto-box" [ngClass]="selectedCrypto === crypto ? 'active' : 'inactive'"
      (click)="selectCryptoType(crypto)"
    >
      <div class="crypto-image-container">
        <img
          src="{{ crypto.currencyImage }}"
          alt=""
          class="crypto-image"
        />
        <img
          *ngIf="crypto.networkImage"
          src="{{ crypto.networkImage }}"
          alt=""
          class="crypto-image"
        />
      </div>
      <div class="crypto-code text-center mt-2">
        <span class="crypto-code-text font-weight-bold"> {{ crypto.currencyCode }}</span>
      </div>
    </div>
  </div>

  <div class="mb-2 amount-input-container">
    <div class="form-group amount-form-group">
      <label for="amount" class="form-label">
        {{ "CRYPTO.AMOUNT" | translate }} ({{ selectedCrypto.currencyShortCode.toUpperCase() }}):
        <span class="text-danger">*</span>
      </label>
      <input
        type="number"
        id="amount"
        class="form-control"
        [(ngModel)]="amount"
        (input)="onAmountChange()"
        [min]="minAmount"
        [max]="maxAmount"
        [placeholder]="'CRYPTO.ENTER_AMOUNT' | translate"
        required
      />
      <strong *ngIf="amount" class="text-green amount-display" style="display: block; padding-top: 5px;">{{ "CRYPTO.WILL_BE_ADDED_TO_YOUR_ACCOUNT" | translate }}: {{amount * currencyRate | number:'1.2-2' }} {{ currentCurrency.currency }}</strong>
      <div class="form-text d-flex align-items-center min-amount" style="padding:5px 0px">
        <strong>1 {{selectedCrypto.currencyCode}} = {{ currencyRate | number:'1.2-2' }} {{ currentCurrency.currency }} /</strong>
        <strong class="ml-1">{{ "CRYPTO.MIN_AMOUNT" | translate }}: {{ selectedCrypto?.minDepositAmount }} {{ selectedCrypto?.currencyCode }}</strong>
      </div>
      <div class="text-danger" *ngIf="amountError">
        {{ amountError | translate }}
      </div>
    </div>
    <div class="continue-button-container">
      <button class="w-100 btn btn-success" (click)="continue()" [disabled]="!selectedCrypto || !this.validateAmount()">Continue</button>
    </div>
  </div>
</div>

<div class="d-flex justify-content-center align-items-center selected-crypto-container" *ngIf="this.step != 'step-1'">
  <div
      class="{{ selectedCrypto.network }} crypto-box active"
    >
    <div class="crypto-image-container">
      <img
        src="{{ selectedCrypto.currencyImage }}"
        alt=""
        class="crypto-image"
      />
      <img
        *ngIf="selectedCrypto.networkImage"
        src="{{ selectedCrypto.networkImage }}"
        alt=""
        class="crypto-image"
      />
    </div>
    <div class="crypto-code text-center mt-2">
      <span class="crypto-code-text font-weight-bold"> {{ selectedCrypto.currencyCode }}</span>
    </div>
  </div>
</div>

<div class="step-2" *ngIf="step == 'step-2'">
  <div class="step-2-content">
    <div>
      <ul class="description-list">
        <li *ngFor="let description of selectedCrypto.description;" [innerHTML]="description"></li>
      </ul>
      <div class="risks-confirmation">
        {{"CRYPTO.RISKS_CONFIRMATION" | translate }}  
      </div>
    </div>
  </div>

  <button class="w-100 btn btn-success confirm-button" (click)="confirm()">Confirm</button>
</div>

<div class="step-3" *ngIf="step == 'step-3'">
  <h5 class="currency-rate-title">1 {{selectedCrypto.currencyCode}} = {{ (parseFloat(estimatePriceData?.estimated_amount) || 0) | number:'1.2-2' }} {{ currentCurrency.currency }}</h5>
  <h5 class="amount-display-title">{{ "CRYPTO.AMOUNT" | translate }}: <strong *ngIf="amount" class="text-green">{{amount | cryptoPrecision:selectedCrypto.currencyCode }} {{ selectedCrypto.currencyCode }}</strong></h5>
  <h5 class="copy-address-title">{{ "CRYPTO.COPY_ADDRESS_OR_SCAN_QR_CODE" | translate }}</h5>
  <h5 class="deposit-address">
    {{ depositData?.payAddress }}
    <i
      class="pi pi-copy"
      style="font-size: 1.5rem; color: rgb(81, 121, 19); cursor: pointer"
      [cdkCopyToClipboard]="depositData?.payAddress"

    ></i>
  </h5>
  <div class="column-center my-3 qr-code-container">
    <qrcode [qrdata]="depositData?.payAddress" [width]="qrCodeWidth"></qrcode>
    <!-- [bc-width]="1" [bc-height]="50" -->
  </div>
  <p class="rule-box">
    <li *ngFor="let note of selectedCrypto.note;" [innerHTML]="note"></li>
  </p>
</div>
